import { render, staticRenderFns } from "./ryzsCov.vue?vue&type=template&id=6ca1ba5a&scoped=true"
import script from "./ryzsCov.vue?vue&type=script&lang=js"
export * from "./ryzsCov.vue?vue&type=script&lang=js"
import style0 from "./ryzsCov.vue?vue&type=style&index=0&id=6ca1ba5a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca1ba5a",
  null
  
)

export default component.exports